var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSmartphone = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 13,
  height: 19,
  viewBox: "0 0 13 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.75825 3.16684C1.75825 2.73422 2.10896 2.38351 2.54158 2.38351H10.4582C10.8909 2.38351 11.2416 2.73422 11.2416 3.16684V15.8335C11.2416 16.2661 10.8909 16.6168 10.4582 16.6168H2.54158C2.10896 16.6168 1.75825 16.2661 1.75825 15.8335V3.16684ZM2.54158 0.783508C1.2253 0.783508 0.158249 1.85056 0.158249 3.16684V15.8335C0.158249 17.1498 1.2253 18.2168 2.54158 18.2168H10.4582C11.7745 18.2168 12.8416 17.1498 12.8416 15.8335V3.16684C12.8416 1.85056 11.7745 0.783508 10.4582 0.783508H2.54158ZM6.5 13.45C6.05817 13.45 5.7 13.8082 5.7 14.25C5.7 14.6918 6.05817 15.05 6.5 15.05H6.508C6.94983 15.05 7.308 14.6918 7.308 14.25C7.308 13.8082 6.94983 13.45 6.508 13.45H6.5Z",
  fill: "white"
})));
export default SvgIconSmartphone;